import React from 'react';
import { Building2 } from 'lucide-react';

interface Step1Data {
  business_name: string;
}

interface Step1BusinessProps {
  data: Step1Data;
  onChange: (data: Step1Data) => void;
}

export function Step1Business({ data, onChange }: Step1BusinessProps) {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Building2 className="w-4 h-4" />
          Wat is de naam van je bedrijf?
        </label>
        <input
          type="text"
          value={data.business_name}
          onChange={(e) => onChange({ ...data, business_name: e.target.value })}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all text-lg"
          placeholder="Bakkerij De Korenbloem"
          autoFocus
        />
      </div>
    </div>
  );
}
